import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const PaymentMethodList = lazy(() => import('../Pages/PaymentMethodList'));
const PaymentMethodAdd = lazy(() => import('../Pages/PaymentMethodAdd'));
const PaymentMethodEdit = lazy(() => import('../Pages/PaymentMethodEdit'));
const PaymentMethodView = lazy(() => import('../Pages/PaymentMethodView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/payment-method.scss';

function PaymentMethodRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/settings/payment-methods"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <PaymentMethodList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/list"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <PaymentMethodList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/add"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <PaymentMethodAdd history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/edit/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <PaymentMethodEdit history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/view/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <PaymentMethodView history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  );
};

export default PaymentMethodRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
